<form class="NgxEditor__Wrapper" [formGroup]="reactiveForm" #editorInput>
    <div class="editor">
        <ngx-editor-menu *ngIf="showMenu" [customMenuRef]="customMenuRef" [editor]="editor" [toolbar]="toolbar"
            [colorPresets]="colorPresets">
        </ngx-editor-menu>
        <ngx-editor [outputFormat]="'html'" [class.without-toolbar]="!showToolBar" [editor]="editor"
            formControlName="editorControl" [placeholder]="placeholder">
        </ngx-editor>
    </div>
</form>

<ng-template #customMenuRef>
    <input type="file" #fileInput (change)="onFileSelected($event)" style="display: none;" accept="image/*">
    <button style="cursor: pointer;" mat-icon-button (click)="fileInput?.click()">
        <mat-icon [svgIcon]="'heroicons_solid:camera'"></mat-icon>
    </button>
    <button class="ml-2" style="cursor: pointer;" mat-icon-button (click)="toPlaintText()">
        <mat-icon style="width: 20px; height: 20px; max-width: 20px; max-height: 20px; font-size: 20px;"
            [svgIcon]="'heroicons_outline:plaint-text'"></mat-icon>
    </button>
</ng-template>